import React, { FunctionComponent } from 'react'
import { Path, Rect, Svg } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'

/**
 * Circle with diagonal slash icon - typically used to indicate "disabled" or "cleared"
 */
export const CircleSlashIcon: FunctionComponent<CircleSlashIconProps> = ({ size = 14, fillColor }) => {
  const { colors } = useTheme()

  return (
    <Svg width={size} height={size} viewBox='0 0 14 14' fill='none' testID={tID('CircleSlashIcon')}>
      <Rect
        x='0.5'
        y='0.5'
        width='12.3333'
        height='12.3333'
        rx='6.16667'
        stroke={fillColor || colors.iconDefault}
        strokeWidth='1'
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.31303 8.68687C5.11776 8.4916 5.11776 8.17502 5.31303 7.97976L8.14145 5.15133C8.33672 4.95607 8.6533 4.95607 8.84856 5.15133C9.04382 5.34659 9.04382 5.66318 8.84856 5.85844L6.02013 8.68687C5.82487 8.88213 5.50829 8.88213 5.31303 8.68687Z'
        fill={fillColor || colors.iconDefault}
      />
    </Svg>
  )
}

type CircleSlashIconProps = {
  size?: number
  fillColor?: string
}
